@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.treeadd.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.treeadd.resources/"

@delegate:ResourceContentHash(1_719_682_390)
internal val Res.string.treeadd_certainty_certain: StringResource by lazy {
      StringResource("string:treeadd_certainty_certain", "treeadd_certainty_certain", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 333, 45),
      ))
    }

@delegate:ResourceContentHash(-2_083_757_757)
internal val Res.string.treeadd_certainty_probable: StringResource by lazy {
      StringResource("string:treeadd_certainty_probable", "treeadd_certainty_probable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 379, 46),
      ))
    }

@delegate:ResourceContentHash(516_503_600)
internal val Res.string.treeadd_certainty_to_confirm: StringResource by lazy {
      StringResource("string:treeadd_certainty_to_confirm", "treeadd_certainty_to_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 426, 52),
      ))
    }

@delegate:ResourceContentHash(-791_544_058)
internal val Res.string.treeadd_error_create: StringResource by lazy {
      StringResource("string:treeadd_error_create", "treeadd_error_create", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 479, 116),
      ))
    }

@delegate:ResourceContentHash(1_420_507_852)
internal val Res.string.treeadd_retry: StringResource by lazy {
      StringResource("string:treeadd_retry", "treeadd_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 596, 37),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.treeadd_species_suggest_cancel: StringResource by lazy {
      StringResource("string:treeadd_species_suggest_cancel", "treeadd_species_suggest_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 634, 50),
      ))
    }

@delegate:ResourceContentHash(1_976_538_357)
internal val Res.string.treeadd_species_suggest_comment_label: StringResource by lazy {
      StringResource("string:treeadd_species_suggest_comment_label", "treeadd_species_suggest_comment_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 685, 77),
      ))
    }

@delegate:ResourceContentHash(1_209_111_350)
internal val Res.string.treeadd_species_suggest_comment_placeholder: StringResource by lazy {
      StringResource("string:treeadd_species_suggest_comment_placeholder", "treeadd_species_suggest_comment_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 763, 95),
      ))
    }

@delegate:ResourceContentHash(526_142_311)
internal val Res.string.treeadd_species_suggest_dialog_title: StringResource by lazy {
      StringResource("string:treeadd_species_suggest_dialog_title", "treeadd_species_suggest_dialog_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 859, 72),
      ))
    }

@delegate:ResourceContentHash(1_971_316_140)
internal val Res.string.treeadd_species_suggest_error: StringResource by lazy {
      StringResource("string:treeadd_species_suggest_error", "treeadd_species_suggest_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 932, 109),
      ))
    }

@delegate:ResourceContentHash(642_802_112)
internal val Res.string.treeadd_species_suggest_name_label: StringResource by lazy {
      StringResource("string:treeadd_species_suggest_name_label", "treeadd_species_suggest_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1042, 66),
      ))
    }

@delegate:ResourceContentHash(-1_518_042_111)
internal val Res.string.treeadd_species_suggest_quota_error: StringResource by lazy {
      StringResource("string:treeadd_species_suggest_quota_error", "treeadd_species_suggest_quota_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1109, 143),
      ))
    }

@delegate:ResourceContentHash(-1_515_281_033)
internal val Res.string.treeadd_species_suggest_send: StringResource by lazy {
      StringResource("string:treeadd_species_suggest_send", "treeadd_species_suggest_send", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1253, 48),
      ))
    }

@delegate:ResourceContentHash(-612_653_280)
internal val Res.string.treeadd_species_suggest_sent: StringResource by lazy {
      StringResource("string:treeadd_species_suggest_sent", "treeadd_species_suggest_sent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1302, 156),
      ))
    }

@delegate:ResourceContentHash(73_249_105)
internal val Res.string.wizard_back_to_place: StringResource by lazy {
      StringResource("string:wizard_back_to_place", "wizard_back_to_place", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1459, 64),
      ))
    }

@delegate:ResourceContentHash(-1_833_165_426)
internal val Res.string.wizard_back_to_species: StringResource by lazy {
      StringResource("string:wizard_back_to_species", "wizard_back_to_species", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1524, 66),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.wizard_cancel: StringResource by lazy {
      StringResource("string:wizard_cancel", "wizard_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1591, 33),
      ))
    }

@delegate:ResourceContentHash(146_164_363)
internal val Res.string.wizard_choice_hint: StringResource by lazy {
      StringResource("string:wizard_choice_hint", "wizard_choice_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1625, 114),
      ))
    }

@delegate:ResourceContentHash(-86_467_898)
internal val Res.string.wizard_choice_site_hint: StringResource by lazy {
      StringResource("string:wizard_choice_site_hint", "wizard_choice_site_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1740, 79),
      ))
    }

@delegate:ResourceContentHash(-1_538_029_594)
internal val Res.string.wizard_choice_site_title: StringResource by lazy {
      StringResource("string:wizard_choice_site_title", "wizard_choice_site_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1820, 44),
      ))
    }

@delegate:ResourceContentHash(-892_126_659)
internal val Res.string.wizard_choice_title: StringResource by lazy {
      StringResource("string:wizard_choice_title", "wizard_choice_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1865, 63),
      ))
    }

@delegate:ResourceContentHash(1_348_621_188)
internal val Res.string.wizard_choice_tree_hint: StringResource by lazy {
      StringResource("string:wizard_choice_tree_hint", "wizard_choice_tree_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1929, 59),
      ))
    }

@delegate:ResourceContentHash(1_183_043_428)
internal val Res.string.wizard_choice_tree_title: StringResource by lazy {
      StringResource("string:wizard_choice_tree_title", "wizard_choice_tree_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1989, 44),
      ))
    }

@delegate:ResourceContentHash(1_650_036_694)
internal val Res.string.wizard_details_hint: StringResource by lazy {
      StringResource("string:wizard_details_hint", "wizard_details_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2034, 131),
      ))
    }

@delegate:ResourceContentHash(-423_103_255)
internal val Res.string.wizard_details_status_hint: StringResource by lazy {
      StringResource("string:wizard_details_status_hint", "wizard_details_status_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2166, 106),
      ))
    }

@delegate:ResourceContentHash(-904_934_899)
internal val Res.string.wizard_details_status_title: StringResource by lazy {
      StringResource("string:wizard_details_status_title", "wizard_details_status_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2273, 71),
      ))
    }

@delegate:ResourceContentHash(-819_503_037)
internal val Res.string.wizard_details_title: StringResource by lazy {
      StringResource("string:wizard_details_title", "wizard_details_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2345, 64),
      ))
    }

@delegate:ResourceContentHash(249_602_486)
internal val Res.string.wizard_duplicate_confirm: StringResource by lazy {
      StringResource("string:wizard_duplicate_confirm", "wizard_duplicate_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2488, 44),
      ))
    }

@delegate:ResourceContentHash(-45_681_127)
internal val Res.string.wizard_duplicate_confirm_expanded: StringResource by lazy {
      StringResource("string:wizard_duplicate_confirm_expanded", "wizard_duplicate_confirm_expanded", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2410, 77),
      ))
    }

@delegate:ResourceContentHash(-1_905_755_132)
internal val Res.string.wizard_duplicate_subtitle: StringResource by lazy {
      StringResource("string:wizard_duplicate_subtitle", "wizard_duplicate_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2533, 77),
      ))
    }

@delegate:ResourceContentHash(1_560_386_225)
internal val Res.string.wizard_duplicate_title: StringResource by lazy {
      StringResource("string:wizard_duplicate_title", "wizard_duplicate_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2611, 66),
      ))
    }

@delegate:ResourceContentHash(850_155_628)
internal val Res.string.wizard_exit_body: StringResource by lazy {
      StringResource("string:wizard_exit_body", "wizard_exit_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2678, 84),
      ))
    }

@delegate:ResourceContentHash(507_187_830)
internal val Res.string.wizard_exit_continue: StringResource by lazy {
      StringResource("string:wizard_exit_continue", "wizard_exit_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2763, 56),
      ))
    }

@delegate:ResourceContentHash(-1_309_018_753)
internal val Res.string.wizard_exit_quit: StringResource by lazy {
      StringResource("string:wizard_exit_quit", "wizard_exit_quit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2820, 36),
      ))
    }

@delegate:ResourceContentHash(-276_588_911)
internal val Res.string.wizard_exit_title: StringResource by lazy {
      StringResource("string:wizard_exit_title", "wizard_exit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2857, 65),
      ))
    }

@delegate:ResourceContentHash(2_768_330)
internal val Res.string.wizard_lost_and: StringResource by lazy {
      StringResource("string:wizard_lost_and", "wizard_lost_and", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2923, 27),
      ))
    }

@delegate:ResourceContentHash(1_796_224_352)
internal val Res.string.wizard_lost_note: StringResource by lazy {
      StringResource("string:wizard_lost_note", "wizard_lost_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2951, 36),
      ))
    }

@delegate:ResourceContentHash(291_077_741)
internal val Res.string.wizard_lost_species: StringResource by lazy {
      StringResource("string:wizard_lost_species", "wizard_lost_species", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2988, 39),
      ))
    }

@delegate:ResourceContentHash(273_195_894)
internal val Res.string.wizard_lost_status: StringResource by lazy {
      StringResource("string:wizard_lost_status", "wizard_lost_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3028, 46),
      ))
    }

@delegate:ResourceContentHash(-1_103_674_931)
internal val Res.string.wizard_next: StringResource by lazy {
      StringResource("string:wizard_next", "wizard_next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3075, 31),
      ))
    }

@delegate:ResourceContentHash(-214_905)
internal val Res.string.wizard_note_label: StringResource by lazy {
      StringResource("string:wizard_note_label", "wizard_note_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3107, 33),
      ))
    }

@delegate:ResourceContentHash(-141_137_110)
internal val Res.string.wizard_note_placeholder: StringResource by lazy {
      StringResource("string:wizard_note_placeholder", "wizard_note_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3141, 83),
      ))
    }

@delegate:ResourceContentHash(-962_452_343)
internal val Res.string.wizard_photo_description: StringResource by lazy {
      StringResource("string:wizard_photo_description", "wizard_photo_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3225, 48),
      ))
    }

@delegate:ResourceContentHash(231_383_239)
internal val Res.string.wizard_photo_failed: StringResource by lazy {
      StringResource("string:wizard_photo_failed", "wizard_photo_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3274, 43),
      ))
    }

@delegate:ResourceContentHash(-563_180_348)
internal val Res.string.wizard_photo_percent: StringResource by lazy {
      StringResource("string:wizard_photo_percent", "wizard_photo_percent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3318, 36),
      ))
    }

@delegate:ResourceContentHash(387_218_287)
internal val Res.string.wizard_photo_remove: StringResource by lazy {
      StringResource("string:wizard_photo_remove", "wizard_photo_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3355, 55),
      ))
    }

@delegate:ResourceContentHash(492_274_470)
internal val Res.string.wizard_photo_sending_description: StringResource by lazy {
      StringResource("string:wizard_photo_sending_description", "wizard_photo_sending_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3411, 76),
      ))
    }

@delegate:ResourceContentHash(-115_625_219)
internal val Res.string.wizard_photo_sending_unknown_description: StringResource by lazy {
      StringResource("string:wizard_photo_sending_unknown_description", "wizard_photo_sending_unknown_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3488, 84),
      ))
    }

@delegate:ResourceContentHash(1_718_683_620)
internal val Res.string.wizard_photo_waiting: StringResource by lazy {
      StringResource("string:wizard_photo_waiting", "wizard_photo_waiting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3646, 44),
      ))
    }

@delegate:ResourceContentHash(604_132_375)
internal val Res.string.wizard_photo_waiting_description: StringResource by lazy {
      StringResource("string:wizard_photo_waiting_description", "wizard_photo_waiting_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3573, 72),
      ))
    }

@delegate:ResourceContentHash(-1_782_417_282)
internal val Res.string.wizard_photos_add: StringResource by lazy {
      StringResource("string:wizard_photos_add", "wizard_photos_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3753, 37),
      ))
    }

@delegate:ResourceContentHash(1_821_633_350)
internal val Res.string.wizard_photos_add_description: StringResource by lazy {
      StringResource("string:wizard_photos_add_description", "wizard_photos_add_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3691, 61),
      ))
    }

@delegate:ResourceContentHash(1_412_275_005)
internal val Res.string.wizard_photos_hint: StringResource by lazy {
      StringResource("string:wizard_photos_hint", "wizard_photos_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3791, 118),
      ))
    }

@delegate:ResourceContentHash(275_316_782)
internal val Res.string.wizard_photos_progress: StringResource by lazy {
      StringResource("string:wizard_photos_progress", "wizard_photos_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3910, 74),
      ))
    }

@delegate:ResourceContentHash(-507_268_572)
internal val Res.string.wizard_photos_title: StringResource by lazy {
      StringResource("string:wizard_photos_title", "wizard_photos_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3985, 35),
      ))
    }

@delegate:ResourceContentHash(1_224_827_044)
internal val Res.string.wizard_place_header_expanded: StringResource by lazy {
      StringResource("string:wizard_place_header_expanded", "wizard_place_header_expanded", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4021, 60),
      ))
    }

@delegate:ResourceContentHash(1_993_115_606)
internal val Res.string.wizard_place_hint_expanded: StringResource by lazy {
      StringResource("string:wizard_place_hint_expanded", "wizard_place_hint_expanded", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4082, 154),
      ))
    }

@delegate:ResourceContentHash(1_557_865_468)
internal val Res.string.wizard_place_tip_1: StringResource by lazy {
      StringResource("string:wizard_place_tip_1", "wizard_place_tip_1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4237, 126),
      ))
    }

@delegate:ResourceContentHash(1_394_220_996)
internal val Res.string.wizard_place_tip_2: StringResource by lazy {
      StringResource("string:wizard_place_tip_2", "wizard_place_tip_2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4364, 94),
      ))
    }

@delegate:ResourceContentHash(-125_342_050)
internal val Res.string.wizard_place_tip_3: StringResource by lazy {
      StringResource("string:wizard_place_tip_3", "wizard_place_tip_3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4459, 130),
      ))
    }

@delegate:ResourceContentHash(-725_192_519)
internal val Res.string.wizard_recap: StringResource by lazy {
      StringResource("string:wizard_recap", "wizard_recap", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4660, 36),
      ))
    }

@delegate:ResourceContentHash(1_988_388_864)
internal val Res.string.wizard_recap_position: StringResource by lazy {
      StringResource("string:wizard_recap_position", "wizard_recap_position", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4590, 69),
      ))
    }

@delegate:ResourceContentHash(1_038_504_895)
internal val Res.string.wizard_segment_details: StringResource by lazy {
      StringResource("string:wizard_segment_details", "wizard_segment_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4697, 42),
      ))
    }

@delegate:ResourceContentHash(-62_478_434)
internal val Res.string.wizard_segment_place: StringResource by lazy {
      StringResource("string:wizard_segment_place", "wizard_segment_place", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4740, 36),
      ))
    }

@delegate:ResourceContentHash(694_727_719)
internal val Res.string.wizard_segment_species: StringResource by lazy {
      StringResource("string:wizard_segment_species", "wizard_segment_species", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4777, 42),
      ))
    }

@delegate:ResourceContentHash(-151_421_167)
internal val Res.string.wizard_species_around_heading: StringResource by lazy {
      StringResource("string:wizard_species_around_heading", "wizard_species_around_heading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4820, 101),
      ))
    }

@delegate:ResourceContentHash(-264_093_939)
internal val Res.string.wizard_species_certain_description: StringResource by lazy {
      StringResource("string:wizard_species_certain_description", "wizard_species_certain_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4922, 110),
      ))
    }

@delegate:ResourceContentHash(-440_587_827)
internal val Res.string.wizard_species_certainty_title: StringResource by lazy {
      StringResource("string:wizard_species_certainty_title", "wizard_species_certainty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5033, 78),
      ))
    }

@delegate:ResourceContentHash(-125_647_528)
internal val Res.string.wizard_species_change: StringResource by lazy {
      StringResource("string:wizard_species_change", "wizard_species_change", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5112, 41),
      ))
    }

@delegate:ResourceContentHash(1_693_087_933)
internal val Res.string.wizard_species_chosen_label: StringResource by lazy {
      StringResource("string:wizard_species_chosen_label", "wizard_species_chosen_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5154, 55),
      ))
    }

@delegate:ResourceContentHash(1_026_191_121)
internal val Res.string.wizard_species_count_none: StringResource by lazy {
      StringResource("string:wizard_species_count_none", "wizard_species_count_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5210, 45),
      ))
    }

@delegate:ResourceContentHash(-1_786_985_405)
internal val Res.string.wizard_species_hint: StringResource by lazy {
      StringResource("string:wizard_species_hint", "wizard_species_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5256, 119),
      ))
    }

@delegate:ResourceContentHash(767_734_869)
internal val Res.string.wizard_species_next_hint: StringResource by lazy {
      StringResource("string:wizard_species_next_hint", "wizard_species_next_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5376, 80),
      ))
    }

@delegate:ResourceContentHash(111_551_307)
internal val Res.string.wizard_species_no_result_hint: StringResource by lazy {
      StringResource("string:wizard_species_no_result_hint", "wizard_species_no_result_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5457, 145),
      ))
    }

@delegate:ResourceContentHash(564_800_589)
internal val Res.string.wizard_species_no_result_title: StringResource by lazy {
      StringResource("string:wizard_species_no_result_title", "wizard_species_no_result_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5603, 94),
      ))
    }

@delegate:ResourceContentHash(213_778_936)
internal val Res.string.wizard_species_probable_description: StringResource by lazy {
      StringResource("string:wizard_species_probable_description", "wizard_species_probable_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5698, 107),
      ))
    }

@delegate:ResourceContentHash(1_229_918_150)
internal val Res.string.wizard_species_search_clear: StringResource by lazy {
      StringResource("string:wizard_species_search_clear", "wizard_species_search_clear", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5806, 63),
      ))
    }

@delegate:ResourceContentHash(-329_660_125)
internal val Res.string.wizard_species_search_placeholder: StringResource by lazy {
      StringResource("string:wizard_species_search_placeholder", "wizard_species_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5870, 69),
      ))
    }

@delegate:ResourceContentHash(831_114_072)
internal val Res.string.wizard_species_season_heading: StringResource by lazy {
      StringResource("string:wizard_species_season_heading", "wizard_species_season_heading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5940, 69),
      ))
    }

@delegate:ResourceContentHash(526_142_311)
internal val Res.string.wizard_species_suggest: StringResource by lazy {
      StringResource("string:wizard_species_suggest", "wizard_species_suggest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6010, 58),
      ))
    }

@delegate:ResourceContentHash(-1_234_007_946)
internal val Res.string.wizard_species_tile_description: StringResource by lazy {
      StringResource("string:wizard_species_tile_description", "wizard_species_tile_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6069, 55),
      ))
    }

@delegate:ResourceContentHash(-761_513_136)
internal val Res.string.wizard_species_title: StringResource by lazy {
      StringResource("string:wizard_species_title", "wizard_species_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6125, 52),
      ))
    }

@delegate:ResourceContentHash(-399_791_645)
internal val Res.string.wizard_species_to_confirm_description: StringResource by lazy {
      StringResource("string:wizard_species_to_confirm_description", "wizard_species_to_confirm_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6178, 117),
      ))
    }

@delegate:ResourceContentHash(796_273_501)
internal val Res.string.wizard_species_unavailable_message: StringResource by lazy {
      StringResource("string:wizard_species_unavailable_message", "wizard_species_unavailable_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6296, 106),
      ))
    }

@delegate:ResourceContentHash(-1_868_116_664)
internal val Res.string.wizard_species_unavailable_title: StringResource by lazy {
      StringResource("string:wizard_species_unavailable_title", "wizard_species_unavailable_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6403, 92),
      ))
    }

@delegate:ResourceContentHash(1_367_288_911)
internal val Res.string.wizard_status_flowering: StringResource by lazy {
      StringResource("string:wizard_status_flowering", "wizard_status_flowering", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6496, 51),
      ))
    }

@delegate:ResourceContentHash(-534_294_247)
internal val Res.string.wizard_status_picked_clean: StringResource by lazy {
      StringResource("string:wizard_status_picked_clean", "wizard_status_picked_clean", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6548, 46),
      ))
    }

@delegate:ResourceContentHash(1_405_459_023)
internal val Res.string.wizard_status_ripe_ready: StringResource by lazy {
      StringResource("string:wizard_status_ripe_ready", "wizard_status_ripe_ready", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6595, 56),
      ))
    }

@delegate:ResourceContentHash(-1_390_441_352)
internal val Res.string.wizard_step_counter: StringResource by lazy {
      StringResource("string:wizard_step_counter", "wizard_step_counter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6704, 51),
      ))
    }

@delegate:ResourceContentHash(-1_880_038_192)
internal val Res.string.wizard_step_counter_neutral: StringResource by lazy {
      StringResource("string:wizard_step_counter_neutral", "wizard_step_counter_neutral", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6652, 51),
      ))
    }

@delegate:ResourceContentHash(1_621_495_898)
internal val Res.string.wizard_step_state: StringResource by lazy {
      StringResource("string:wizard_step_state", "wizard_step_state", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6814, 57),
      ))
    }

@delegate:ResourceContentHash(1_613_074_610)
internal val Res.string.wizard_step_state_neutral: StringResource by lazy {
      StringResource("string:wizard_step_state_neutral", "wizard_step_state_neutral", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6756, 57),
      ))
    }

@delegate:ResourceContentHash(-780_788_285)
internal val Res.string.wizard_submit: StringResource by lazy {
      StringResource("string:wizard_submit", "wizard_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7100, 41),
      ))
    }

@delegate:ResourceContentHash(2_134_771_502)
internal val Res.string.wizard_submit_hint: StringResource by lazy {
      StringResource("string:wizard_submit_hint", "wizard_submit_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6872, 98),
      ))
    }

@delegate:ResourceContentHash(1_850_399_518)
internal val Res.string.wizard_submit_uploading_hint: StringResource by lazy {
      StringResource("string:wizard_submit_uploading_hint", "wizard_submit_uploading_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6971, 128),
      ))
    }

@delegate:ResourceContentHash(854_815_724)
internal val Res.string.wizard_title_add: StringResource by lazy {
      StringResource("string:wizard_title_add", "wizard_title_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7142, 48),
      ))
    }

@delegate:ResourceContentHash(-62_478_434)
internal val Res.string.wizard_title_place: StringResource by lazy {
      StringResource("string:wizard_title_place", "wizard_title_place", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7191, 34),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("treeadd_certainty_certain", Res.string.treeadd_certainty_certain)
  map.put("treeadd_certainty_probable", Res.string.treeadd_certainty_probable)
  map.put("treeadd_certainty_to_confirm", Res.string.treeadd_certainty_to_confirm)
  map.put("treeadd_error_create", Res.string.treeadd_error_create)
  map.put("treeadd_retry", Res.string.treeadd_retry)
  map.put("treeadd_species_suggest_cancel", Res.string.treeadd_species_suggest_cancel)
  map.put("treeadd_species_suggest_comment_label", Res.string.treeadd_species_suggest_comment_label)
  map.put("treeadd_species_suggest_comment_placeholder", Res.string.treeadd_species_suggest_comment_placeholder)
  map.put("treeadd_species_suggest_dialog_title", Res.string.treeadd_species_suggest_dialog_title)
  map.put("treeadd_species_suggest_error", Res.string.treeadd_species_suggest_error)
  map.put("treeadd_species_suggest_name_label", Res.string.treeadd_species_suggest_name_label)
  map.put("treeadd_species_suggest_quota_error", Res.string.treeadd_species_suggest_quota_error)
  map.put("treeadd_species_suggest_send", Res.string.treeadd_species_suggest_send)
  map.put("treeadd_species_suggest_sent", Res.string.treeadd_species_suggest_sent)
  map.put("wizard_back_to_place", Res.string.wizard_back_to_place)
  map.put("wizard_back_to_species", Res.string.wizard_back_to_species)
  map.put("wizard_cancel", Res.string.wizard_cancel)
  map.put("wizard_choice_hint", Res.string.wizard_choice_hint)
  map.put("wizard_choice_site_hint", Res.string.wizard_choice_site_hint)
  map.put("wizard_choice_site_title", Res.string.wizard_choice_site_title)
  map.put("wizard_choice_title", Res.string.wizard_choice_title)
  map.put("wizard_choice_tree_hint", Res.string.wizard_choice_tree_hint)
  map.put("wizard_choice_tree_title", Res.string.wizard_choice_tree_title)
  map.put("wizard_details_hint", Res.string.wizard_details_hint)
  map.put("wizard_details_status_hint", Res.string.wizard_details_status_hint)
  map.put("wizard_details_status_title", Res.string.wizard_details_status_title)
  map.put("wizard_details_title", Res.string.wizard_details_title)
  map.put("wizard_duplicate_confirm", Res.string.wizard_duplicate_confirm)
  map.put("wizard_duplicate_confirm_expanded", Res.string.wizard_duplicate_confirm_expanded)
  map.put("wizard_duplicate_subtitle", Res.string.wizard_duplicate_subtitle)
  map.put("wizard_duplicate_title", Res.string.wizard_duplicate_title)
  map.put("wizard_exit_body", Res.string.wizard_exit_body)
  map.put("wizard_exit_continue", Res.string.wizard_exit_continue)
  map.put("wizard_exit_quit", Res.string.wizard_exit_quit)
  map.put("wizard_exit_title", Res.string.wizard_exit_title)
  map.put("wizard_lost_and", Res.string.wizard_lost_and)
  map.put("wizard_lost_note", Res.string.wizard_lost_note)
  map.put("wizard_lost_species", Res.string.wizard_lost_species)
  map.put("wizard_lost_status", Res.string.wizard_lost_status)
  map.put("wizard_next", Res.string.wizard_next)
  map.put("wizard_note_label", Res.string.wizard_note_label)
  map.put("wizard_note_placeholder", Res.string.wizard_note_placeholder)
  map.put("wizard_photo_description", Res.string.wizard_photo_description)
  map.put("wizard_photo_failed", Res.string.wizard_photo_failed)
  map.put("wizard_photo_percent", Res.string.wizard_photo_percent)
  map.put("wizard_photo_remove", Res.string.wizard_photo_remove)
  map.put("wizard_photo_sending_description", Res.string.wizard_photo_sending_description)
  map.put("wizard_photo_sending_unknown_description", Res.string.wizard_photo_sending_unknown_description)
  map.put("wizard_photo_waiting", Res.string.wizard_photo_waiting)
  map.put("wizard_photo_waiting_description", Res.string.wizard_photo_waiting_description)
  map.put("wizard_photos_add", Res.string.wizard_photos_add)
  map.put("wizard_photos_add_description", Res.string.wizard_photos_add_description)
  map.put("wizard_photos_hint", Res.string.wizard_photos_hint)
  map.put("wizard_photos_progress", Res.string.wizard_photos_progress)
  map.put("wizard_photos_title", Res.string.wizard_photos_title)
  map.put("wizard_place_header_expanded", Res.string.wizard_place_header_expanded)
  map.put("wizard_place_hint_expanded", Res.string.wizard_place_hint_expanded)
  map.put("wizard_place_tip_1", Res.string.wizard_place_tip_1)
  map.put("wizard_place_tip_2", Res.string.wizard_place_tip_2)
  map.put("wizard_place_tip_3", Res.string.wizard_place_tip_3)
  map.put("wizard_recap", Res.string.wizard_recap)
  map.put("wizard_recap_position", Res.string.wizard_recap_position)
  map.put("wizard_segment_details", Res.string.wizard_segment_details)
  map.put("wizard_segment_place", Res.string.wizard_segment_place)
  map.put("wizard_segment_species", Res.string.wizard_segment_species)
  map.put("wizard_species_around_heading", Res.string.wizard_species_around_heading)
  map.put("wizard_species_certain_description", Res.string.wizard_species_certain_description)
  map.put("wizard_species_certainty_title", Res.string.wizard_species_certainty_title)
  map.put("wizard_species_change", Res.string.wizard_species_change)
  map.put("wizard_species_chosen_label", Res.string.wizard_species_chosen_label)
  map.put("wizard_species_count_none", Res.string.wizard_species_count_none)
  map.put("wizard_species_hint", Res.string.wizard_species_hint)
  map.put("wizard_species_next_hint", Res.string.wizard_species_next_hint)
  map.put("wizard_species_no_result_hint", Res.string.wizard_species_no_result_hint)
  map.put("wizard_species_no_result_title", Res.string.wizard_species_no_result_title)
  map.put("wizard_species_probable_description", Res.string.wizard_species_probable_description)
  map.put("wizard_species_search_clear", Res.string.wizard_species_search_clear)
  map.put("wizard_species_search_placeholder", Res.string.wizard_species_search_placeholder)
  map.put("wizard_species_season_heading", Res.string.wizard_species_season_heading)
  map.put("wizard_species_suggest", Res.string.wizard_species_suggest)
  map.put("wizard_species_tile_description", Res.string.wizard_species_tile_description)
  map.put("wizard_species_title", Res.string.wizard_species_title)
  map.put("wizard_species_to_confirm_description", Res.string.wizard_species_to_confirm_description)
  map.put("wizard_species_unavailable_message", Res.string.wizard_species_unavailable_message)
  map.put("wizard_species_unavailable_title", Res.string.wizard_species_unavailable_title)
  map.put("wizard_status_flowering", Res.string.wizard_status_flowering)
  map.put("wizard_status_picked_clean", Res.string.wizard_status_picked_clean)
  map.put("wizard_status_ripe_ready", Res.string.wizard_status_ripe_ready)
  map.put("wizard_step_counter", Res.string.wizard_step_counter)
  map.put("wizard_step_counter_neutral", Res.string.wizard_step_counter_neutral)
  map.put("wizard_step_state", Res.string.wizard_step_state)
  map.put("wizard_step_state_neutral", Res.string.wizard_step_state_neutral)
  map.put("wizard_submit", Res.string.wizard_submit)
  map.put("wizard_submit_hint", Res.string.wizard_submit_hint)
  map.put("wizard_submit_uploading_hint", Res.string.wizard_submit_uploading_hint)
  map.put("wizard_title_add", Res.string.wizard_title_add)
  map.put("wizard_title_place", Res.string.wizard_title_place)
}
